module.exports = __webpack_public_path__ + "5428d7a00f4fde696273f73797a1dad3.png";